import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BreadCrumb, NavItem, SessionNotification } from '@pt/pt-models';
import { StorageInfo } from '@primatoo-ms-organization';
import { ID_DASHBOARD_LAYOUT, ID_DASHBOARD_LAYOUT_CONTAINER } from '../utils';
import { PtCoreSelectors } from '@pt/pt-core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'pt-dashboard-layout',
  template: `
    <div class="h-100" [id]="ID">
      <pt-navbar [itemLeft]='navbarItemsLeft'
                 [itemRight]='navbarItemsRight'>
      </pt-navbar>

      <pt-sidebar [items]='sidebarItems'
                  [version]="version"
                  [storageInfo]='storageInfo'
                  [administration]='isAdministrator'>

        <ng-container sidebarContent>
          <ng-sidebar-container [id]="ID_CONTAINER"
                                class='ng-sidebar-container-session-detail'>
            <ng-sidebar [mode]="'over'"
                        [dock]="false"
                        [animate]="true"
                        [keyClose]="false"
                        [autoFocus]="true"
                        [trapFocus]="false"
                        [position]="'right'"
                        [showBackdrop]="false"
                        [autoCollapseWidth]="null"
                        [autoCollapseHeight]="null"
                        [opened]="isOpenSessionInfo"
                        [closeOnClickOutside]="true"
                        [closeOnClickBackdrop]="false"
                        [ariaLabel]="'sidebar-session-info'"
                        [sidebarClass]='"ng-sidebar--custom ng-sidebar--custom--session-info"'
                        (onClosed)="clickCloseSessionInfo.emit()">
              <pt-session-notification class="d-flex"
                                       [sessionNotifications]="sessionNotifications"
                                       (closeSessionNotification)="clickCloseSessionInfo.emit()"
                                       (deleteSessionNotification)="deleteSessionInfo.emit($event)">
              </pt-session-notification>
            </ng-sidebar>

<!--             Page content -->
            <div ng-sidebar-content class="ng-sidebar-content">
              <div class="feature-page">
                <ng-content></ng-content>
              </div>
            </div>
          </ng-sidebar-container>
        </ng-container>
      </pt-sidebar>
    </div>
  `,
  styles: [`
    .ng-sidebar-content {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    .feature-page {
      width: 100%;
      min-width: 1000px;
      overflow-y: auto;
      overflow-x: hidden;
      background: white;
      flex-grow: 1
    }
  `]
})
export class DashboardLayoutComponent {
  @Input() isAdministrator: boolean;
  @Input() sidebarItems: NavItem[];
  @Input() storageInfo: StorageInfo;
  @Input() breadcrumbs: BreadCrumb[];
  @Input() navbarItemsLeft: NavItem[];
  @Input() navbarItemsRight: NavItem[];
  @Input() isOpenSessionInfo: boolean;
  @Input() sessionNotifications: SessionNotification[];
  @Input() version?: string;
  public loginResponse$ = this.store.select(PtCoreSelectors.loginResponse);

  @Output() clickCloseSessionInfo = new EventEmitter();
  @Output() deleteSessionInfo = new EventEmitter<SessionNotification[]>();

  ID = ID_DASHBOARD_LAYOUT;
  ID_CONTAINER = ID_DASHBOARD_LAYOUT_CONTAINER;

  constructor(private store: Store) {
  }
}
